/**
 * Filtres permettant de récupérer une liste de dossier. Gere la pagination, la zone de recherche libre et une liste de filtres
 * 
 * Données de recherche : 
 *  searchData: {
 *      configuration {
            size:10,
            from:0,
        }
        filters:[],
        text: 'F0W 123'
    }

    Exemple de filtre : 
    filters:[
        {
            data: '$.event.origin.type'
            operator: 'EQUAL'
            values : ["PANNE", "CARBU"]
        },
        ...
    ]
 * Operateurs sur les filtres : operator filtres : 
 EQUAL, SUPERIOR, SUPERIOR_OR_EQUAL, INFERIOR, INFERIOR_OR_EQUAL, LIKE
 * 
 */

const initialState = {
    searchData: {
        configuration: {
            from: 0,
            size: 10,
            aggregat: []
        },
        filters: [
            {
                data: '$.creation_date',
                order: 'DESC',
                values: []
            }
        ]
    }
}

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

function reduceFilters(state = initialState, action) {
    let nextState;

    //state.searchData.configuration.size = 10;
    state.searchData.configuration.from = 0;

    switch (action.type) {
        case 'FREE_SEARCH':
            state.searchData.text = action.contenu.value;
            if (action.contenu.immediate) {
                nextState = JSON.parse(JSON.stringify(state));
            }
            return nextState || state;

        case 'ADD_MONO_FILTER':
            let indexFilter = -1;
            if (state.searchData.filters) {
                indexFilter = state.searchData.filters.findIndex(item => item.data === action.contenu.data)
            }
            if (indexFilter !== -1) { // filtre existant
                // Si values est non vide, on met à jour le filtre existant avec cette valeur
                if (action.contenu.values) {
                    action.contenu.values = [action.contenu.values];
                    state.searchData.filters[indexFilter] = action.contenu;
                } else {
                    // Si pas de valeur, suppressin du filtre mono valeur
                    state.searchData.filters.splice(indexFilter, 1);
                }
            } else { // Ajout d'un nouveeau filtre mono valeur
                if (!state.searchData.filters) {
                    state.searchData.filters = [];
                }
                action.contenu.values = [action.contenu.values];
                state.searchData.filters = [...state.searchData.filters, action.contenu];
            }
            nextState = JSON.parse(JSON.stringify(state));

            return nextState;

        case 'ADD_MULTI_FILTER':
            let indexMultiFilter = -1;
            if (state.searchData.filters) {
                indexMultiFilter = state.searchData.filters.findIndex(item => item.data === action.contenu.data)
            }

            if (indexMultiFilter !== -1) { // Filtre existant, ajout de la valeur dans la liste des values (si celle-ci existe).
                let currentFiltre = state.searchData.filters[indexMultiFilter];
                if (!currentFiltre.values) {
                    currentFiltre.values = [action.contenu.values];
                } else {
                    currentFiltre.values = [...currentFiltre.values, action.contenu.values].filter(onlyUnique);
                }
            } else { // Ajout d'un nouveau filtre
                if (!state.searchData.filters) {
                    state.searchData.filters = [];
                }
                action.contenu.values = [action.contenu.values];
                state.searchData.filters = [...state.searchData.filters, action.contenu];
            }
            nextState = JSON.parse(JSON.stringify(state)); // vieux hack moisi pour forcer le render. TODO : apprendre à coder

            return nextState;

        case 'ADD_MULTI_FILTER_ARRAY':
            // On cherche si il existe un filtre sur le nom donné dans action.data
            let indexMultiArrayFilter = -1;
            if (state.searchData.filters) {
                indexMultiArrayFilter = state.searchData.filters.findIndex(item => item.data === action.contenu.data)
            }

            if (indexMultiArrayFilter !== -1) {
                // Filtre existant, toutes les valeurs actuelles sont remplacées avec le nouvel Array de values dans action.contenu.values
                let currentFiltre = state.searchData.filters[indexMultiArrayFilter];
                currentFiltre.values = action.contenu.values;

            } else {
                // Ajout d'un nouveau filtre
                if (!state.searchData.filters) {
                    state.searchData.filters = [];
                }
                state.searchData.filters = [...state.searchData.filters, action.contenu];
            }
            nextState = JSON.parse(JSON.stringify(state)); // vieux hack moisi pour forcer le render. TODO : apprendre à coder

            return nextState;

        case 'ADD_INTERVAL_FILTER':
            // Ajout d'un filtre type interval. values doit contenir 2 valeurs, debut et fin, chacune optionnelle.
            if (!action.contenu.values || action.contenu.values.length !== 2) {
                console.log('filtre interval incohérent');
            } else if (!action.contenu.values[0] && !action.contenu.values[1]) {
                console.log('filtre interval sans valeurs');
            } else {
                // Premiere valur, filtre type plus grand que
                // Vérification si filtre existe sur le nom du filtre + operateur.
                // Si oui, on le remplace
                // Si non, on le crée
                let startIndex = state.searchData.filters.findIndex(item => item.data === action.contenu.data && item.operator === "GTE")

                if (startIndex !== -1) {
                    if (action.contenu.values[0] && action.contenu.values[0] !== "") {
                        // Filtre existant, on remplace la valeur
                        state.searchData.filters[startIndex].values = [action.contenu.values[0]];
                    } else {
                        state.searchData.filters.splice(startIndex, 1);
                    }
                } else if (action.contenu.values[0] && action.contenu.values[0] !== "") {
                    let newStartFilter = {
                        data: action.contenu.data,
                        operator: 'GTE',
                        values: [action.contenu.values[0]],
                        type: 'date'
                    }
                    state.searchData.filters = [...state.searchData.filters, newStartFilter];
                }

                // Deuxieme valeur, filtre type plus petit que
                let endIndex = state.searchData.filters.findIndex(item => item.data === action.contenu.data && item.operator === "LTE")
                if (endIndex !== -1) {
                    if (action.contenu.values[1] && action.contenu.values[1] !== "") {
                        // Filtre existant, on remplace la valeur
                        state.searchData.filters[endIndex].values = [action.contenu.values[1]];
                    } else {
                        state.searchData.filters.splice(endIndex, 1);
                    }
                } else if (action.contenu.values[1] && action.contenu.values[1] !== "") {
                    let newEndFilter = {
                        data: action.contenu.data,
                        operator: 'LTE',
                        values: [action.contenu.values[1]],
                        type: 'date'
                    }
                    state.searchData.filters = [...state.searchData.filters, newEndFilter];
                }
                nextState = JSON.parse(JSON.stringify(state));
            }

            return nextState || state;

        case 'ADD_QUANTITY_FILTER':
            // Ajout d'un filtre type interval. values doit contenir 2 valeurs, debut et fin, chacune optionnelle.

            let filters = [...state.searchData.filters];
            // Premiere valur, filtre type plus grand que
            // Vérification si filtre existe sur le nom du filtre + operateur.
            // Si oui, on le remplace
            // Si non, on le crée
            filters = filters.filter(item => item.data !== action.contenu.data);

            if (action.contenu.values[0] && action.contenu.values[0].trim() !== '') {
                let newStartFilter = {
                    data: action.contenu.data,
                    operator: 'GTE',
                    values: [action.contenu.values[0]],
                    type: 'quantity'
                }
                filters = [...filters, newStartFilter];
            }
            if (action.contenu.values && action.contenu.values[1] && action.contenu.values[1].trim() !== '') {
                let newEndFilter = {
                    data: action.contenu.data,
                    operator: 'LTE',
                    values: [action.contenu.values[1]],
                    type: 'quantity'
                }
                filters = [...filters, newEndFilter];
            }

            state.searchData.filters = [...filters];
            nextState = JSON.parse(JSON.stringify(state));


            return nextState || state;


        case 'REMOVE_MULTI_FILTER':
            let indexRemoveFilter = -1;
            if (state.searchData.filters) {
                indexRemoveFilter = state.searchData.filters.findIndex(item => item.data === action.contenu.data)
            }

            if (indexRemoveFilter !== -1) { // Filtre existant, suppression de la valeur dans la liste des values (si celle-ci existe. si elle existe pas, y a un souci ailleurs).
                let listValues = state.searchData.filters[indexRemoveFilter].values;
                listValues.splice(listValues.indexOf(action.contenu.values), 1);

                // Si il n'y a plus d'élement dans la liste, suppression filtre
                if (state.searchData.filters[indexRemoveFilter].values.length < 1) {
                    state.searchData.filters.splice(indexRemoveFilter, 1);
                }
                nextState = JSON.parse(JSON.stringify(state));
            }
            return nextState || state;


        case 'REMOVE_FILTER_BY_NAME':
            state.searchData.filters = state.searchData.filters.filter(item => item.data !== action.contenu.data);
            nextState = JSON.parse(JSON.stringify(state));
            return nextState;

        case 'RESET_FILTER':
            // state.searchData = {
            //     configuration: {
            //         from: 0,
            //         size: 10
            //     },
            //     filters:[]
            // }
            state.searchData.filters = [{
                data: '$.creation_date',
                order: 'DESC',
                values: []
            }];
            nextState = JSON.parse(JSON.stringify(state));
            return nextState;

        case 'REFRESH':
            nextState = JSON.parse(JSON.stringify(state));
            return nextState;

        case 'PAGINATION_SIZE':
            state.searchData.configuration.size = action.size;
            nextState = JSON.parse(JSON.stringify(state));

            return nextState;

        case 'PAGINATION_FROM':
            state.searchData.configuration.from = action.from;
            nextState = JSON.parse(JSON.stringify(state));

            return nextState;

        case 'SORT':
            let sortDirection = action.order.toUpperCase();
            // Il ne peut y avoir qu'un seul filtre de tri. Suppression de tout les autres filtres avec un order
            let noFilters = {};
            if (state.searchData.filters) noFilters = state.searchData.filters.filter(item => !item.order);
            let indexSortFilter = -1;
            if (state.searchData.filters) {
                indexSortFilter = noFilters.findIndex(item => item.data === action.data)
            }

            if (indexSortFilter !== -1) { // Filtre existant, maj de son order
                let currentFiltre = state.searchData.filters[indexSortFilter];
                currentFiltre.order = sortDirection;
            } else { // Ajout d'un nouveau filtre
                if (!state.searchData.filters) {
                    state.searchData.filters = [];
                }
                let newFilter = {
                    data: action.data,
                    order: sortDirection,
                    values: []
                }
                state.searchData.filters = [...noFilters, newFilter];
            }
            nextState = JSON.parse(JSON.stringify(state));

            return nextState;

        default:
            return state
    }
}

export default reduceFilters